export const subScriptionStatus = {
    live: {
        name: 'Live',
        color: 'rgb(0, 144, 73)'
    },
    cancel: {
        name: 'Canceled',
        color: 'red'
    }
}